import { render, staticRenderFns } from "./GroupeList.vue?vue&type=template&id=a6229fee"
import script from "./GroupeList.vue?vue&type=script&lang=ts"
export * from "./GroupeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports